// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { AbstractQueryParams, TypesaurusCoreDoc } from '@res/ngg-core';
import { InvoiceModel, InvoiceRef, InvoiceUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace InvoiceActions {
  export class GetAllInvoice {
    static readonly type = '[Invoice] GetAllInvoice';
    readonly type = GetAllInvoice.type;
  }

  export class InitInvoices {
    static readonly type = '[Invoice] InitInvoices';
    constructor(public id?: string) {}
  }

  export class CloseInvoicesConnection {
    static readonly type = '[Invoice] CloseInvoicesConnection';
    readonly type = CloseInvoicesConnection.type;
  }

  export class GetInvoiceById {
    static readonly type = '[Invoice] GetInvoiceById';
    readonly type = GetInvoiceById.type;
  }

  export class UpdateInvoice {
    static readonly type = '[Invoice] UpdateInvoice';
    constructor(
      public invoiceData: Partial<InvoiceUpdateData>,
      public ref: InvoiceRef,
    ) {}
  }

  export class UpdateInvoiceResult {
    static readonly type = '[Invoice] UpdateInvoiceResult';
    constructor(public data: Array<TypesaurusCoreDoc<InvoiceModel> | null | undefined>) {}
  }

  export class DeleteInvoice {
    static readonly type = '[Invoice] DeleteInvoice';
    readonly type = DeleteInvoice.type;
  }

  export class QueryInvoice {
    static readonly type = '[Invoice] QueryInvoice';

    constructor(
      public filter: {
        query: AbstractQueryParams<InvoiceModel>[];
      },
    ) {}
  }
  export class InvoiceError {
    static readonly type = '[Invoice] InvoiceError';

    constructor(public error: Error) {}
  }
}
